import type * as Monaco from 'monaco-editor'

let monacoLoadPromise: Promise<typeof Monaco> | null = null

/**
 * 统一从本地 bundle 初始化 Monaco，避免 @monaco-editor/loader 默认走远程 CDN。
 */
export function loadLocalMonaco(): Promise<typeof Monaco> {
  if (monacoLoadPromise) {
    return monacoLoadPromise
  }

  monacoLoadPromise = (async () => {
    const [{ default: loader }, monacoModule] = await Promise.all([
      import('@monaco-editor/loader'),
      import('monaco-editor'),
    ])
    loader.config({ monaco: monacoModule } as Parameters<typeof loader.config>[0])
    return loader.init()
  })().catch((error: unknown) => {
    monacoLoadPromise = null
    throw error
  })

  return monacoLoadPromise
}

export function preloadLocalMonaco(): void {
  if (import.meta.env.MODE === 'test') {
    return
  }

  void loadLocalMonaco().catch(() => {
    // 预热失败不打断页面；代码节点打开时仍可走 textarea 降级。
  })
}

export function scheduleMonacoPreload(): () => void {
  if (import.meta.env.MODE === 'test' || typeof window === 'undefined') {
    return () => {}
  }

  if (window.requestIdleCallback) {
    const idleId = window.requestIdleCallback(() => preloadLocalMonaco(), { timeout: 1500 })
    return () => window.cancelIdleCallback?.(idleId)
  }

  const timeoutId = window.setTimeout(preloadLocalMonaco, 1200)
  return () => window.clearTimeout(timeoutId)
}
